var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeCommentActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5133 15.3333H17.6933L18.7067 12.04C18.92 11.3533 18.36 10.6667 17.5867 10.6667C17.2 10.6667 16.8267 10.8267 16.5733 11.1L12.6667 15.3333H10V22H12.6667H13.3333H19.62C20.3267 22 20.94 21.5533 21.08 20.9267L21.9733 16.9267C22.1533 16.1 21.4533 15.3333 20.5133 15.3333ZM12.6667 21.3333H10.6667V16H12.6667V21.3333ZM21.32 16.78L20.4267 20.78C20.36 21.1 20.02 21.3333 19.62 21.3333H13.3333V15.5933L17.0667 11.5533C17.1933 11.4133 17.3867 11.3333 17.5867 11.3333C17.76 11.3333 17.92 11.4067 18.0067 11.5333C18.0533 11.6 18.1067 11.7067 18.0667 11.8467L17.0533 15.14L16.7867 16H17.6867H20.5067C20.78 16 21.04 16.1133 21.1933 16.3067C21.28 16.4067 21.3667 16.5733 21.32 16.78Z",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeCommentActive);
export default __webpack_public_path__ + "static/media/like-comment-active.82914e029d5cdb0b2d206b51ce5fc2b2.svg";
export { ForwardRef as ReactComponent };